const observeStore = (store, select, onChange) => {
  let currentState = select(store.getState());

  const handleChange = () => {
    const nextState = select(store.getState());
    if (nextState !== currentState) {
      currentState = nextState;
      onChange(currentState);
    }
  };

  return store.subscribe(handleChange);
};

export default observeStore;
